<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('invoice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('invoice.pageTitle'), href: '/invoices' },
          { text: $t('create'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading_eligable">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <form>
                  <fieldset>
                    <legend>{{ $t('invoice.createFrom') }}</legend>
                    <student-list
                      v-model="model"
                      @student-info="student => (studentInfo = student)"
                      :validate="errors"
                    />
                  </fieldset>
                </form>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <form>
                  <fieldset>
                    <legend>{{ $t('invoice.academic') }}</legend>
                    <academic-info
                      v-model="model"
                      :student-info="studentInfo"
                      :validate="errors"
                    />
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <panel :title="$t('invoice.itemList')">
                  <item-detail
                    v-model="model"
                    :item-details="itemDetails"
                    :validate="errors"
                    :loading-item-detail="loading_item_detail"
                    :bank="bankProfiles"
                  />
                  <div v-if="errors.has('inv_detail_list')" class="validate">
                    {{ errors.first('inv_detail_list') }}
                  </div>
                  <template slot="footer">
                    <div class="row">
                      <div class="col-md-12 text-right">
                        <ts-button
                          @click.prevent="$router.push({ name: 'invoice' })"
                          >{{ $t('cancel') }}</ts-button
                        >
                        <ts-button
                          :waiting="save_print"
                          color="primary"
                          outline
                          class="ml-2"
                          @click.prevent="savePrint"
                          >{{ $t('savePrint') }}</ts-button
                        >
                        <ts-button
                          :waiting="waiting"
                          @click.prevent="save"
                          color="primary"
                          class="ml-2"
                          >{{ $t('save') }}</ts-button
                        >
                      </div>
                    </div>
                  </template>
                </panel>
              </div>
            </div>
          </div>
        </ts-loading-banner>
        <pdf-preview
          v-model="pdf_view"
          :invoice-id="invoiceId"
          @cancel="value => (pdf_view = value)"
        />
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import { StudentList, AcademicInfo, ItemDetail, PdfPreview } from './components'

export default {
  name: 'invoiceCreateForm',
  components: {
    StudentList,
    AcademicInfo,
    ItemDetail,
    PdfPreview
  },
  data() {
    return {
      model: {
        pre_inv_id: 0,
        inv_date: moment().format('DD-MM-YYYY'),
        student_id: null,
        acp_id: null,
        acps_id: null,
        semester: null,
        grade_id: null,
        level_id: null,
        year: null,
        total_amount: 0,
        amount_paid: 0,
        amount_due: 0,
        next_payment_date: null,
        remark: null,
        inv_detail_list: [],
        payment_method_id: 1,
        bank_id: null,
        amount_paid_khr: 0,
        amount_paid_usd: 0
      },
      exchange_rate: 0,
      loading_eligable: false,
      waiting: false,
      loading_item_detail: false,
      pdf_view: false,
      save_print: false,
      errors: new Errors(),
      itemDetails: {},
      invoiceId: 0,
      studentInfo: null,
      bankProfiles: []
    }
  },
  created() {},
  methods: {
    ...mapActions('officailReceiptModule', [ 'onSave' ]),
    async save() {
      this.errors = new Errors()
      this.waiting = true
        this.waiting = true
        this.onSave(this.model)
          .then(response => {
            this.$toasted.success(response.data.message)
            this.$router.push({ name: 'invoice' })
          })
        	.catch(error => {
						this.$toasted.error(error.response.data.message)
						this.errors = new Errors(error.response.data.errors)
					})
          .finally(() => {
            this.waiting = false
          })
    },
    async savePrint() {
      this.errors = new Errors()
      this.save_print = true
        this.onSave(this.model)
          .then(response => {
            this.$toasted.success(response.data.message)
            this.clearInput()
            this.invoiceId = response.data.id
            this.pdf_view = true
          })
        	.catch(error => {
						this.$toasted.error(error.response.data.message)
						this.errors = new Errors(error.response.data.errors)
					})
          .finally(() => {
            this.save_print = false
          })
    },
    clearInput() {
      this.model.pre_inv_id = 0
      this.model.inv_date = moment().format('DD-MM-YYYY')
      this.model.student_id = null
      this.model.ac_year_id = null
      this.model.acp_id = null
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = null
      this.model.grade_id = null
      this.model.level_id = null
      this.model.student_name = null
			this.model.main_program = null
			this.model.sub_program = null
			this.model.year = null
			this.model.semester = null
      this.model.total_amount = 0
      this.model.amount_paid = 0
      this.model.amount_due = 0
      this.model.next_payment_date = null
      this.model.remark = null
      this.model.inv_detail_list = []
      this.itemDetails = {}
      this.model.payment_method_id = null
      this.model.bank_id = null
      this.model.amount_paid_usd = 0
      this.model.amount_paid_khr = 0
      this.studentInfo = null
    }
  }
}
</script>

<style lang="css" scoped>
* {
  font-size: 12px !important;
}

.page-header {
  font-size: 24px !important;
}

.panel {
  margin-bottom: -24px !important;
}
</style>
